/* istanbul ignore file */
// TODO: ^ ignore coverage on this file until we can have app test scaffolding ready
import React from 'react'
import { RouteContentGetter } from 'layers/content/v2/Hocs/RouteContentGetter'
import withApiError from 'layers/errorHandling/apiError'
import TieredInterventionsUnitsPage from './component'
import { resolveRouteServiceApp } from 'utils/productHelpers'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContext'
import { CourseManagerGetter } from 'layers/content/v2/Hocs/CourseManagerGetter'

import { selectCurrentClassInstanceData } from 'utils/lmsHelpers'

const TieredInterventionsContainer = props => {
  const {
    match,
    location,
    navigationEvent,
    routeContent,
    instructorData,
    courseManager,
    userContext,
  } = props || {}
  const { content = {}, loading } = routeContent || {}

  const handleTabChange = tab => {
    const { query } = location
    const destination = `${tab.route}?${new URLSearchParams(query)?.toString()}`
    navigationEvent(destination)
  }

  let selectedClass = null
  let readyToLoad = false

  if (match?.params?.verb === 'teach') {
    const { ourClass } = selectCurrentClassInstanceData({
      instructorData,
      courseManager,
      match,
      userContext,
      location,
    })

    selectedClass = ourClass
    readyToLoad = !!selectedClass && !!content && !loading
  } else {
    readyToLoad = !!content && !loading
  }

  return (
    readyToLoad && (
      <TieredInterventionsUnitsPage
        content={content}
        handleTabChange={handleTabChange}
        match={match}
        navigationEvent={navigationEvent}
        ourClass={selectedClass}
      />
    )
  )
}

const options = {
  app: ({ route }) => resolveRouteServiceApp(route),
  routeResolver: () => window?.location?.pathname,
}

export default withSiteContext(
  CourseManagerGetter(
    RouteContentGetter(withApiError(TieredInterventionsContainer), options),
  ),
)
